import { api } from "../api";

/**
 * commandQueueDeleteById - Function that deletes a queued command by its ID  
 * /commands/queue/{id}      
 * method DELETE 
 * @async-function
 */
const commandQueueDeleteById = async (token: string, id: number) => {
    const response = await api.delete(
        `/commands/queue/${id}`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }
    );
    return response;
};

export default commandQueueDeleteById;
